<template>
  <v-card>
    <v-card-title class="secondary--text headline font-weight-medium justify-center">
      HISTÓRICO DO DIA
    </v-card-title>
    <v-toolbar color="secondary">
      <v-menu
        ref="menu"
        v-model="menu"
        :close-on-content-click="false"
        lazy
        transition="slide-y-transition"
        offset-y
        full-width
        min-width="290px"
      >
        <template v-slot:activator="{ on }">
          <v-btn flat small v-on="on">
            <span class="black--text headline font-weight-medium">{{date}}</span>
          </v-btn>
        </template>
        <v-date-picker v-model="new_date" no-title scrollable color="black" locale="pt-br"></v-date-picker>
      </v-menu>
      <v-spacer></v-spacer>
      <v-flex xs5 class="pa-0 ma-0">
        <v-select
          label="Relatório"
          class="mt-3"
          :items="[
            { text: 'Voucher Pessoa Física', value: 1 },
            { text: 'Voucher Pessoa Juridica', value: 2 },
            { text: 'PIX', value: 3 },
            { text: 'Vendas de Assinatura', value: 4 },
          ]"
          item-text="text"
          v-model="filtro"
        />
      </v-flex>
      <v-spacer></v-spacer>
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn flat v-on="on" icon @click="printData()">
            <v-icon color="black">print</v-icon>
          </v-btn>
        </template>
        Imprimir
      </v-tooltip>
    </v-toolbar>
    <v-card-text only>
      <v-layout justify-center v-if="filtro !== 3">
          <v-select
            label="Filtrar por tipo de pagamento"
            :items="tipos_pagamentos"
            item-text="descricao"
            item-value="id_tipo_pagamento"
            v-model="id_tipo_pagamento"
            prepend-icon="filter_alt"
            solo
            clearable
          ></v-select>
        </v-layout>
      <v-list
        three-line
        :class="local ? 'pt-0' : 'pt-0 print'"
        v-if="caixa && caixa.length && filtro === 1 ||  filtro === 2"
      >
        <h1
          class="secondary--text headline font-weight-medium text-xs-center mb-4"
        >
          Relatório Vouchers
        </h1>
        <v-divider></v-divider>
        <template v-for="(voucher, index) in caixa">
          <v-divider v-if="index > 0" :key="index"></v-divider>
          <v-list-tile
            avatar
            :key="`index-${index}`"
            :id="`index-${index}`"
            :class="local ? 'pt-0 print' : 'pt-0'"
            style="height: 16em;"
          >
            <v-list-tile-action>
              <v-tooltip
                v-if="voucher.combustivel"
                :color="voucher.combustivel ? voucher.combustivel.color: ''"
                top
              >
                <template v-slot:activator="{ on }">
                  <span v-on="on">
                    <svg-filler
                      :path="
                        voucher.combustivel && voucher.combustivel.icone ?
                        require(`@/assets/combs/${voucher.combustivel.icone}.svg`) :
                        require(`@/assets/combs/gas.svg`)"
                      width="40px"
                      height="40px"
                      :fill="voucher.combustivel ? voucher.combustivel.color: ''"
                    />
                  </span>
                </template>
                <span>{{ voucher.combustivel ? voucher.combustivel.nome : 'Indefinido' }}</span>
              </v-tooltip>
            </v-list-tile-action>
            <v-list-tile-content  style="height: 12em; margin-top: 7em;">
              <v-list-tile-title
                v-if="voucher.pessoa"
              >
                {{
                  voucher.empresa ? 'Funcionário' : 'Cliente'
                }} : {{
                        voucher.pessoa ?
                        `${voucher.pessoa.nome || ''} ${voucher.pessoa.sobrenome || ''}` :
                        'Não informado'
                     }}
              </v-list-tile-title>
              <v-list-tile-title
                v-else-if="voucher.veiculo && voucher.veiculo.motorista && voucher.veiculo.motorista.pessoa"
              >
                Cliente: {{`${ voucher.veiculo.motorista.pessoa.nome} ${voucher.veiculo.motorista.pessoa.sobrenome || '' }`}}
              </v-list-tile-title>
              <v-list-tile-title v-if="voucher.empresa">Empresa:  {{voucher.empresa.nome_fantasia}}</v-list-tile-title>
              <v-list-tile-sub-title>
                {{ voucher.valor_total | currency({ fractionCount: 2 }) }}
              </v-list-tile-sub-title>
              <v-list-tile-sub-title
                v-if="
                  voucher.desconto
                "
              >
                Desconto de {{formatarDesconto(voucher.desconto)}}
              </v-list-tile-sub-title>
              <v-list-tile-sub-title v-if="voucher.hora_inativado && voucher.data_inativado">
                {{voucher.hora_inativado.substring(0, 5)}} - {{ voucher.data_inativado.split('-').reverse().join('/') }}
              </v-list-tile-sub-title>
              <v-list-tile-sub-title v-if="voucher.frentista">
                Lido por: {{
                voucher.frentista.nome
              }}
              </v-list-tile-sub-title>
              <v-list-tile-sub-title
                v-if="voucher.metodo_pagamento == 'pospago' && voucher.nsu"
                class="grey--text text--darken-3 caption font-weight-medium"
              >
                NSU: {{voucher.nsu}}
                  <v-tooltip top>
                    <template v-slot:activator="{ on }">
                      <v-btn v-on="on" icon flat @click="copiar(voucher.nsu)">
                        <v-icon size="13">content_copy</v-icon>
                      </v-btn>
                    </template>
                    <span>Copiar NSU</span>
                  </v-tooltip>
              </v-list-tile-sub-title>
              <v-list-tile-sub-title
                v-else-if="voucher.tipo_pagamento"
              >
                Tipo de Pagamento: {{ voucher.tipo_pagamento ? voucher.tipo_pagamento.toUpperCase() : 'EM ESPÉCIE' }}
              </v-list-tile-sub-title>
              <v-list-tile-sub-title class="grey--text text--darken-3 caption font-weight-medium">
                Código do Voucher: {{ voucher.numero }}
                <v-tooltip top>
                    <template v-slot:activator="{ on }">
                      <v-btn v-on="on" icon flat @click="copiar(voucher.numero)">
                        <v-icon size="13">content_copy</v-icon>
                      </v-btn>
                    </template>
                    <span>Copiar Código do Voucher</span>
                  </v-tooltip>
              </v-list-tile-sub-title>
              <v-list-tile-sub-title class="grey--text text--darken-3 caption font-weight-medium">
                Código da Compra: {{ voucher.codigo }}
                <v-tooltip top>
                    <template v-slot:activator="{ on }">
                      <v-btn v-on="on" icon flat @click="copiar(voucher.codigo)">
                        <v-icon size="13">content_copy</v-icon>
                      </v-btn>
                    </template>
                    <span>Copiar Código da Compra</span>
                  </v-tooltip>
              </v-list-tile-sub-title>
            </v-list-tile-content>
            <v-list-tile-content>
              <template v-if="voucher.abastecido">
                <v-list-tile-title
                  class="font-weight-light subheading text-xs-center"
                >
                  Confirmado
                </v-list-tile-title>
                <v-list-tile-title
                  class="text-xs-center font-weight-medium body-2"
                >
                  Cupom n° {{ voucher.codigo_cupom || 'Não informado' }}
                </v-list-tile-title>
              </template>
              <v-list-tile-title
                class="font-weight-bold subheading text-xs-center success--text"
              >
                Abastecido
              </v-list-tile-title>
            </v-list-tile-content>
            <v-list-tile-action>
              <v-layout column fill-height align-center justify-center>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn flat v-on="on" icon @click="imprimir(index)">
                      <v-icon color="primary">print</v-icon>
                    </v-btn>
                  </template>
                  Imprimir
                </v-tooltip>
              </v-layout>
            </v-list-tile-action>
          </v-list-tile>
        </template>
        <v-divider></v-divider>
      </v-list>
      <v-list
        three-line
        :class="local ? 'pt-0' : 'pt-0 print'"
        v-if="((cobrancas && cobrancas.length > 0) || (transacoesPagPix.length > 0)) && filtro === 3"
      >
         <h1 class="secondary--text headline font-weight-medium text-xs-center">Relatório PIX</h1>
         <template v-for="(cobranca, index) in cobrancas">
           <v-divider v-if="index > 0" :key="cobranca.txid" inset></v-divider>
            <v-list-tile
              class="grey lighten-3"
              :style="{ border: 'solid 2px red' }"
              avatar
              :key="index"
            >
              <v-list-tile-action>
                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <span v-on="on">
                      <v-icon color="green darken-2">local_atm</v-icon>
                    </span>
                  </template>
                  <span>/Pix recebidos</span>
                </v-tooltip>
              </v-list-tile-action>
              <v-list-tile-content
                style="height: 110px; font-size: 11pt; font-weight: bold"
              >
                <v-list-tile-title>
                  Pagamento via pix
                </v-list-tile-title>
                <v-list-tile-sub-title
                  style="width: 95%"
                  class="grey--text text--darken-3 caption font-weight-medium"
                >
                  Valor:
                  {{ cobranca.valor | currency({ fractionCount: 2 }) }}
                </v-list-tile-sub-title>
                <v-list-tile-sub-title
                  style="width: 95%"
                  class="grey--text text--darken-3 caption font-weight-medium"
                >
                  Data de utilização:
                  {{
                    dataAtualFormatada(cobranca.calendario)
                  }}
                </v-list-tile-sub-title>
              </v-list-tile-content>
            </v-list-tile>
         </template>
         <template v-for="(transacaoPPB, index) in transacoesPagPix">
          <!-- transacaoPPB = Transação PagPixBank -->
          <v-divider v-if="index > 0" :key="`${index}divider`" inset></v-divider>
          <v-menu
            offset-x
            :key="`${index}menu`"
            left
            transition="slide-x-reverse-transition"
          >

          <template v-slot:activator="{ on }">
              <v-list-tile
                class="grey lighten-3"
                style="border: solid 2px red"
                avatar
                v-on="on"
              >
                <v-list-tile-action>
                  <v-tooltip top>
                    <template v-slot:activator="{ on }">
                      <span v-on="on">
                        <v-icon color="green darken-2">local_atm</v-icon>
                      </span>
                    </template>
                    <span>/Pix recebidos</span>
                  </v-tooltip>
                </v-list-tile-action>
                <v-list-tile-content>
                  <v-list-tile-title>
                    Pagamento via pix
                  </v-list-tile-title>
                  <v-list-tile-sub-title
                    class="grey--text text--darken-3 caption font-weight-medium"
                  >
                    Valor:
                    {{ transacaoPPB.valor | currency({ fractionCount: 2 }) }}
                  </v-list-tile-sub-title>
                  <v-list-tile-sub-title
                    class="grey--text text--darken-3 caption font-weight-medium"
                  >
                    Data de utilização:
                    {{
                      dataAtualFormatada(transacaoPPB.calendario)
                    }}
                  </v-list-tile-sub-title>
                </v-list-tile-content>
                <v-list-tile-content>
                  <v-list-tile-sub-title
                    class="grey--text text--darken-3 caption font-weight-medium"
                  >
                    Status:
                    {{ transacaoPPB.status }}
                  </v-list-tile-sub-title>
                </v-list-tile-content>
              </v-list-tile>
            </template>
          </v-menu>
        </template>
       </v-list>
       <v-list
        three-line
        :class="local ? 'pt-0' : 'pt-0 print'"
        v-if="vendas_assinatura && vendas_assinatura.length > 0 && filtro === 4"
      >
        <h1
            class="secondary--text headline font-weight-medium text-xs-center mb-4"
          >
          Vendas de Assinatura
        </h1>
        <v-divider></v-divider>
        <template v-for="(venda_assinatura, index) in vendas_assinatura">
          <v-divider v-if="index > 0" :key="index"></v-divider>
          <v-list-tile
            avatar
            :key="`${index}va`"
            :id="`${index}va`"
            :class="local ? 'pt-0 print' : 'pt-0'"
            style="height: 16em;"
          >
            <v-list-tile-avatar>
                <v-icon color="secondary">edit</v-icon>
            </v-list-tile-avatar>
            <v-list-tile-content  style="height: 12em; margin-top: 7em;">
              <v-list-tile-title
                v-if="venda_assinatura.cliente"
              >
                {{
                  venda_assinatura.empresa ? 'Funcionário' : 'Cliente'
                }} : {{
                        venda_assinatura.cliente ?
                        `${venda_assinatura.cliente.pessoa.nome || ''} ${venda_assinatura.cliente.pessoa.sobrenome || ''}` :
                        'Não informado'
                     }}
              </v-list-tile-title>
              <v-list-tile-sub-title>
                {{ venda_assinatura.valor | currency({ fractionCount: 2 }) }}
              </v-list-tile-sub-title>
              <v-list-tile-sub-title v-if="venda_assinatura.hora_inativado && venda_assinatura.data_inativado">
                {{ venda_assinatura.hora_inativado.substring(0, 5)}} - {{ venda_assinatura.data_inativado.split('-').reverse().join('/') }}
              </v-list-tile-sub-title>
              <v-list-tile-sub-title v-if="venda_assinatura.frentista">
                Lido por: {{
                venda_assinatura.frentista.nome
              }}
              </v-list-tile-sub-title>
              <v-list-tile-sub-title
                v-if="venda_assinatura.nsu"
                class="grey--text text--darken-3 caption font-weight-medium"
              >
                NSU: {{venda_assinatura.nsu}}
                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <v-btn v-on="on" icon flat @click="copiar(venda_assinatura.nsu)">
                      <v-icon size="13">content_copy</v-icon>
                    </v-btn>
                  </template>
                  <span>Copiar NSU</span>
                </v-tooltip>
              </v-list-tile-sub-title>
              <v-list-tile-sub-title
                v-else-if="venda_assinatura.tipo_pagamento"
              >
                Tipo de Pagamento: {{ venda_assinatura.tipo_pagamento ? venda_assinatura.tipo_pagamento.toUpperCase() : 'EM ESPÉCIE' }}
              </v-list-tile-sub-title>
              <v-list-tile-sub-title class="grey--text text--darken-3 caption font-weight-medium">
                Código da Venda: {{ venda_assinatura.codigo }}
                <v-tooltip top>
                    <template v-slot:activator="{ on }">
                      <v-btn v-on="on" icon flat @click="copiar(venda_assinatura.codigo)">
                        <v-icon size="13">content_copy</v-icon>
                      </v-btn>
                    </template>
                    <span>Copiar Código da Venda</span>
                  </v-tooltip>
              </v-list-tile-sub-title>
            </v-list-tile-content>
            <v-list-tile-action>
              <v-layout column fill-height align-center justify-center>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn flat v-on="on" icon @click="imprimir(`${index}va`)">
                      <v-icon color="primary">print</v-icon>
                    </v-btn>
                  </template>
                  Imprimir
                </v-tooltip>
              </v-layout>
            </v-list-tile-action>
          </v-list-tile>
        </template>
      </v-list>
      <div
        v-else-if="!loading"
        class="text-xs-center grey--text headline font-weight-light text--darken-1"
      >
        <span
          v-if="filtro !== 3 && caixa && caixa.length == 0"
        >
          Sem vouchers lidos no dia {{date}}
        </span>
        <br>
        <span
          v-if="filtro === 3 && ((!cobrancas || cobrancas.length == 0) && (!transacoesPagPix || transacoesPagPix.length == 0))"
        >
          Sem PIX lidos no dia {{date}}
        </span>
      </div>
      <div v-else class="text-xs-center">
        <v-progress-circular indeterminate color="primary"></v-progress-circular>
      </div>
    </v-card-text>
    <v-divider></v-divider>
    <v-card-actions class="justify-space-around">
      <v-flex xs5 class="ma-0 pa-0">
        <h4>Valor Recebido:</h4>
        <h2 class="text-xs-center">
          <b>{{ valor_desconto | currency({ fractionCount: 2 })  }}</b>
        </h2>
      </v-flex>
      <v-divider vertical></v-divider>
      <v-flex xs5 class="ma-0 pa-0">
        <h4>Valor Total:</h4>
        <h2 class="text-xs-center">
          <b>{{ valor_total | currency({ fractionCount: 2 })  }}</b>
        </h2>
      </v-flex>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  props: ['visible'],
  data () {
    return {
      date: new Date().toLocaleDateString(),
      menu: false,
      filtro: 1,
      dates: null,
      new_date: new Date().toISOString().substr(0, 10),
      local: false,
      transacoesPagPix: [],
      meiosPagamento: [],
      tipos_pagamentos: [],
      vendas_assinatura: [],
      total_vendas_assinatura: 0,
      id_tipo_pagamento: undefined,
      valor_total: 0,
      valor_desconto: 0,
      paginationCash: {
        rowsPerPage: 10,
        page: 1
      }
    }
  },
  watch: {
    visible (val) {
      if (val) {
        this.carregarCaixa()
      }
    },
    filtro (val) {
      this.valor_total = 0
      this.valor_desconto = 0
      if (val === 1 || val === 2) this.carregarCaixa()
      else if (val === 4) this.pagamentosDeAssinatura()
      else {
        if (this.meiosPagamento.length > 0) {
          for (let i = 0; i < this.meiosPagamento.length; i++) {
            if (this.meiosPagamento[i].forma_pagamento.descricao.toLowerCase() === 'efipix') this.carregarCobrancas()
            else if (this.meiosPagamento[i].forma_pagamento.descricao.toLowerCase() === 'pagpixbank') this.carregarTransacoesPagPix()
          }
        }
      }
    },
    new_date (val) {
      this.menu = false
      this.valor_total = 0
      this.valor_desconto = 0
      this.formatDate(val)
      if (val && this.filtro === 3) {
        if (this.meiosPagamento.length > 0) {
          for (let i = 0; i < this.meiosPagamento.length; i++) {
            if (this.meiosPagamento[i].forma_pagamento.descricao.toLowerCase() === 'efipix') this.carregarCobrancas()
            else if (this.meiosPagamento[i].forma_pagamento.descricao.toLowerCase() === 'pagpixbank') this.carregarTransacoesPagPix()
          }
        }
      } else if (val && this.filtro === 4) this.pagamentosDeAssinatura()
      else this.carregarCaixa()
    },
    paginationCash: {
      handler (val, oldval) {
        this.carregarCobrancas()
      },
      deep: true
    },
    meiosPagamento (val) {
      if (val.length > 0 && this.filtro === 3) {
        for (let i = 0; i < val.length; i++) {
          if (this.meiosPagamento[i].forma_pagamento.descricao.toLowerCase() === 'efipix') this.carregarCobrancas()
          else if (this.meiosPagamento[i].forma_pagamento.descricao.toLowerCase() === 'pagpixbank') this.carregarTransacoesPagPix()
        }
      }
    },
    cobrancas (val) {
      if (this.filtro === 3 && val.length > 0) {
        val.map(cobranca => {
          this.valor_total += cobranca.valor
          this.valor_desconto += cobranca.valor
        })
      }
    },
    id_tipo_pagamento (val) {
      this.carregarCaixa()
    }
  },
  mounted () {
    this.pegarTiposDePagamento()
    this.pegarMeiosDePagamentosSecundarios()
    if (this.frentista && this.filtro === 3) {
      if (this.meiosPagamento.length > 0 && this.filtro === 3) {
        for (let i = 0; i < this.meiosPagamento.length; i++) {
          if (this.meiosPagamento[i].forma_pagamento.descricao.toLowerCase() === 'efipix') this.carregarCobrancas()
          else if (this.meiosPagamento[i].forma_pagamento.descricao.toLowerCase() === 'pagpixbank') this.carregarTransacoesPagPix()
        }
      }
    } else if (this.filtro === 4) this.pagamentosDeAssinatura()
    else this.carregarCaixa()
  },
  computed: {
    caixa () {
      return this.$store.getters.caixa
    },
    loading () {
      return this.$store.getters.loading
    },
    cobrancas () {
      return this.$store.getters.cobrancas
    },
    frentista () {
      return this.$store.getters.frentista
    },
    pagesCash () {
      let count = this.cobrancas.length
      if (this.paginationCash.rowsPerPage == null || count == null) return 0

      return Math.ceil(count / this.paginationCash.rowsPerPage)
    }
  },
  methods: {
    copiar (codigo) {
      navigator.clipboard.writeText(codigo)
      alert('Copiado')
    },
    maskedCPF (cpf) {
      let newCpf = `${cpf.substr(0, 3)}.${cpf.substr(3, 3)}.${cpf.substr(6, 3)}-${cpf.substr(9, 2)}`
      return newCpf
    },
    formatDate (date) {
      this.date = date
        .split('-')
        .reverse()
        .join('/')
    },
    carregarCaixa () {
      const data = {
        data_inativado: this.date,
        is_empresa: this.filtro === 2,
        posto: this.frentista.posto.cnpj,
        page: 'notPagination'
      }
      if (this.id_tipo_pagamento) data.compra__tipo_pagamento = this.id_tipo_pagamento
      this.$store.dispatch('carregarCaixa', data).then(json => {
        this.valor_total = json.valor_total
        this.valor_desconto = json.valor_desconto
      })
    },
    imprimir (id) {
      let mywindow = window.open('', 'PRINT', 'height=400,width=1080')
      mywindow.document.write(`<html><head><title>${document.title}</title>`)
      mywindow.document.write('</head><body >')
      mywindow.document.write(`<h1>${document.title}</h1>`)
      mywindow.document.write(document.getElementById(id).innerHTML)
      mywindow.document.write('</body></html>')
      mywindow.document.close()
      mywindow.focus()
      mywindow.window.print()
      let interval = setInterval(() => {
        mywindow.close()
        clearInterval(interval)
      }, 1000)
    },
    printData () {
      window.print()
    },
    carregarCobrancas () {
      this.$store.dispatch('listarCobrancas', {
        'page': this.paginationCash.page - 1,
        'data_inicio': this.new_date,
        'data_fim': this.new_date
      })
    },
    carregarTransacoesPagPix () {
      const data = {
        method: 'GET',
        data_inicial: this.new_date,
        data_final: this.new_date,
        tipo_transacao: 'imediata'
      }
      this.$store.dispatch('transacoesPagPixBank', data).then(json => {
        this.transacoesPagPix = json
        json.map(transacao => {
          this.valor_total += transacao.valor
          this.valor_desconto += transacao.valor
        })
      })
    },
    pegarMeiosDePagamentosSecundarios () {
      this.$store.dispatch('pegarMeiosDePagamentosSecundarios').then(json => {
        this.meiosPagamento = json
      })
    },
    dataAtualFormatada (dataCobranca) {
      let data = new Date(dataCobranca)
      let dia = data.getDate().toString().padStart(2, '0')
      let mes = (data.getMonth() + 1).toString().padStart(2, '0')
      let ano = data.getFullYear()
      let hora = data.getHours()
      let min = data.getMinutes()
      return dia + '/' + mes + '/' + ano + ' ' + hora + ':' + min
    },
    pegarTiposDePagamento () {
      this.$store.dispatch('pegarTiposDePagamento').then(json => {
        this.tipos_pagamentos = json
      })
    },
    pagamentosDeAssinatura () {
      const data = {
        id_frentista: this.frentista.id_frentista,
        data_compra: this.new_date,
        total: true,
        metodo_pagamento: 'pospago'
      }
      this.$store.dispatch('pagamentosDeAssinatura', data).then(json => {
        this.vendas_assinatura = json.compras
        this.valor_total = json.valor_total
        this.valor_desconto = json.valor_total
      })
    },
    formatarDesconto (desconto) {
      if (!desconto) return '0%'
      else if (desconto % 1 !== 0) {
        return `R$ ${desconto.toFixed(2).replace('.', ',')}`
      }
      return `${desconto}%`
    }
  }
}
</script>
